import { useState, useRef } from 'react';
import { ChevronDown } from 'lucide-react';

const HoverReveal = ({ children, label = "Découvrir le détail" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef(null);

  const handleEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsOpen(true);
  };

  const handleLeave = () => {
    timeoutRef.current = setTimeout(() => setIsOpen(false), 400);
  };

  return (
    <div
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
    >
      {/* Trigger - fond chocolat, texte beige, texte plus grand */}
      <div
        className={`py-6 text-center cursor-pointer select-none transition-colors duration-300 ${
          isOpen 
            ? 'bg-[#F3E5CF]' 
            : 'bg-[#3F2A24]'
        }`}
        onClick={() => setIsOpen((v) => !v)}
        data-testid="hover-reveal-trigger"
      >
        <p className={`text-base sm:text-lg tracking-[0.25em] uppercase font-medium mb-2 transition-colors duration-300 ${
          isOpen 
            ? 'text-[#3F2A24]' 
            : 'text-[#F3E5CF]'
        }`}>{label}</p>
        <ChevronDown
          className={`w-5 h-5 mx-auto transition-all duration-500 ${
            isOpen 
              ? 'rotate-180 text-[#3F2A24]' 
              : 'text-[#F3E5CF]/80'
          }`}
        />
      </div>
      {/* Content - fond beige, texte chocolat */}
      <div
        className="overflow-hidden transition-all duration-700 ease-in-out bg-[#F3E5CF]"
        style={{
          maxHeight: isOpen ? '8000px' : '0px',
          opacity: isOpen ? 1 : 0,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default HoverReveal;
